// Vuetify 4
import LuxonAdapter from '@date-io/luxon';
import {appThemes, appVuetifyDefaults} from '@s/app_vuetify_theme';
import {createVuetify} from 'vuetify';
import {VBtn} from 'vuetify/components/VBtn';
import {VBtnToggle} from 'vuetify/components/VBtnToggle';
import {VCard} from 'vuetify/components/VCard';
import * as directives from 'vuetify/directives';

// Manually imported - only needed when vite plugin misses something because of dynamic components
// See: https://vuetifyjs.com/en/features/treeshaking/#manual-imports

import {aliases, fa} from 'vuetify/iconsets/fa-svg';

import {VDateInput} from 'vuetify/components/VDateInput';
import {VIconBtn} from 'vuetify/components/VIconBtn';


export const vuetify = createVuetify({
   /*
   components: {
      VCard,
   },
   directives: {
      Ripple,
   },
   */
   components: {
      // Referenced from defaults and dynamic contexts, not templates, so auto-import misses them
      VIconBtn,
      VDateInput,
   },
   directives,
   // Luxon date adapter (the app uses Luxon for all date handling).
   // See: https://vuetifyjs.com/en/features/dates/#using-luxon
   date: {
      adapter: LuxonAdapter,
   },
   icons: {
      defaultSet: 'fa',
      aliases,
      sets: {
         fa,
      },
   },
   // Brand themes replace the stock light/dark; 'system' follows the OS preference
   theme: {
      defaultTheme: 'system',
      themes: appThemes,
   },

   // Aliases to preset component setting values (defaults in app_vuetify_theme.ts)
   aliases: {
      // The one filled-blue primary action per view
      VBtnPrimary: VBtn,
      // Outlined container panel
      VCardPanel: VCard,
      // Button toggle variants with their own defaults
      VSelectorBtnToggle: VBtnToggle,
      VSmallSelectorBtnToggle: VBtnToggle,
   },

   defaults: appVuetifyDefaults,
});
